import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { Spin } from "antd";

import Swal from "sweetalert2";

import ApiService_mall from "../../../apis/ApiService_mall";
import { setLoading } from "../../../redux/store/common/commonDuck";
import { handleIsMallUserWithPartners } from "../LoginUitls";

const api = new ApiService_mall();

const NaverCall = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const setIsLoading = (value) => dispatch(setLoading(value));

	const clinent_id = "uRBnEup5L0wKh3Onbbtq";
	useEffect(() => {
		const naverLogin = new window.naver.LoginWithNaverId({
			clientId: clinent_id,
			callbackUrl: `${process.env.REACT_APP_HOST}/user/sns/naver`,
			callbackHandle: true,
			// isPopup: util.getPlatform !== "Mobile", // 로그인 팝업여부
			loginButton: {
				color: "green", // 색상(white, green)
				type: 3, // 버튼타입(1,2,3)
				height: 60, // 배너 및 버튼 높이
			},
		});

		naverLogin.init();
		naverLogin.logout(); // 네이버 로그인이 계속 유지되는 경우가 있다. 초기화시 로그아웃
		naverLogin.getLoginStatus((status) => {
			if (status) {
				// 필수 제공 동의 조건
				if (naverLogin.user.mobile === undefined) {
					naverLogin.reprompt();
				} else {
					naverLoginSuceess(naverLogin.user);
				}
			} else {
				console.log("Naver 비 로그인 상태");
			}
		});
	}, []);

	const naverLoginSuceess = async (naverUser) => {
		// const influencer_id = sessionStorage.getItem("influencer_id");
		// const influencer_user_id = sessionStorage.getItem("influencer_user_id");
		// const backPage = sessionStorage.getItem("backPage");

		// SNS 가입여부 판단
		let param = {
			provider: "naver",
			provider_id: naverUser.id,
			// influenecer_id: influencer_user_id,
			// phone: naverUser.mobile
			//   ?.replace("-", "")
			//   .replace("-", "")
			//   .replace("+82 ", "0"),
		};
		localStorage.setItem("naverUser", JSON.stringify(naverUser));

		let res = await api.snsValid(param);

		if (res.data.code === 200) {
			const result = res.data.result;

			// 가입 시 로그인 처리
			if (result.is_valid === true) {
				localStorage.removeItem("admin:accessToken");
				localStorage.removeItem("admin:refreshToken");
				localStorage.setItem("admin:accessToken", result.tokenDto.accessToken);
				localStorage.setItem(
					"admin:refreshToken",
					result.tokenDto.refreshToken
				);
				setIsLoading(false);
				await handleIsMallUserWithPartners(result.user, dispatch, history);
			} else {
				if (result.is_user_valid === true) {
					Swal.fire({
						customClass: "alert-custom",
						text: "이미 회원가입이 된 사용자입니다. 아이디 찾기를 진행해주세요.",
						confirmButtonText: "확인",
					}).then(() => {
						// history.replace(`/together/channel/login?id=${influencer_id}`);
						setIsLoading(false);
					});
				} else {
					Swal.fire({
						customClass: "alert-custom",
						text: `회원가입이 필요합니다.`,
						confirmButtonText: "확인",
						// confirmButtonColor: "#212529",
					}).then(() => {
						// history.goBack();
						let snsUserInfo = {
							provider: "naver",
							provider_id: naverUser.id,
							gender: naverUser.gender,
							phone_number: naverUser.mobile,
							birthday: naverUser.birthday,
							birthyear: naverUser.birthyear,
							profile_nickname: naverUser.nickname,
						};
						sessionStorage.setItem("snsUserInfo", JSON.stringify(snsUserInfo));
						history.push(`/user/signup`);
					});
					// history.push(`/user/register/info`);
					setIsLoading(false);
				}
			}
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "네이버 로그인 연동이 실패되었습니다. 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				history.replace(`/login`);
				setIsLoading(false);
			});
		}
	};
	return (
		<>
			<div id="naverIdLogin" />
			<div
				style={{
					margin: "auto",
					width: "100%",
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					zIndex: 999,
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					backgroundColor: "white",
				}}
			>
				<Spin size={"large"} />
			</div>
		</>
	);
};
export default NaverCall;
